// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AZZPZaMNbOjtpHzJGy9Q{color:#fff;position:absolute;text-align:center;width:100%}.O7drda1Yb_mnmRsPcw55{bottom:100px}.Dw6xOAfC2w80MHbXOdrf{bottom:50px}.eqYi5F6zm25CA3NPuGQ5.eqYi5F6zm25CA3NPuGQ5.eqYi5F6zm25CA3NPuGQ5{font-size:20px;font-weight:500;margin-bottom:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clockWrapper": `AZZPZaMNbOjtpHzJGy9Q`,
	"clockWrapperDesktop": `O7drda1Yb_mnmRsPcw55`,
	"clockWrapperMobile": `Dw6xOAfC2w80MHbXOdrf`,
	"text": `eqYi5F6zm25CA3NPuGQ5`
};
export default ___CSS_LOADER_EXPORT___;
